
//Représente les paramètres d’initialisation de la saisie de la référence de commande d’une facture d’achat
export class AeFInitialiserSaisieRefCommandeFactureAchatParametres 
{
  //Identifiant de la facture
  public identifiantFacture!: string;
}

//Représente le résultat de l’initialisation de la saisie de la référence de commande d’une facture d’achat
export class AeFInitialiserSaisieRefCommandeFactureAchatResultat 
{
  //Date de transmission
  public dateTransmission!: Date | null;

  //Date de création de la pièce d’achat
  public dateCreationPieceAchat!: Date | null;

  //Indique si la facture a été transférée vers le back-office, par ses documents ou par sa pièce d’achat
  public transfereVersBackOffice!: boolean;

  //Numéro de commande
  public numeroCommande!: string | null;
}
